export default "/_next/static/chunks/fonts/Roboto Light-8be2d1487420548b3b8ddba68270b26b.ttf";